module.exports = __webpack_public_path__ + "img/breadcrumb-bg-admin.8ba1160d.jpg";